<template>
  <div>
    <!-- <el-table  :data="treeData"
        row-key="idx"
        default-expand-all
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        border style="width: 100%">
        <el-table-column prop="name" label="参数名称"></el-table-column>
        <el-table-column prop="label" label="字段说明"></el-table-column>
        <el-table-column prop="dataType" label="数据类型"></el-table-column>
        <el-table-column prop="value" label="参数值"></el-table-column>
        <el-table-column  label="操作">
            <template slot-scope="scope" >
                <el-button
                  type="text"
                  size="small"
                  @click="addConnectorParam(scope.row)"
                  >增加</el-button
                >


                <el-button
                  type="text"
                  size="small"
                  @click="addConnectorParam(scope.row)"
                  >编辑</el-button
                >

                <el-button
                  type="text"
                  size="small"
                  @click="deleteConnectorParam(scope)"
                  >删除1</el-button
                >
              </template>
        </el-table-column>
    </el-table> -->
    
    
    <el-row class="custom-tree-node-container">
      <el-col :span="5"><span>变量名称</span></el-col>
      <el-col :span="5"><span>变量备注</span></el-col>
      <el-col :span="5"><span>数据类型</span></el-col>
      <el-col :span="5"><span>数据值</span></el-col>
      <el-col :span="4"><span>操作</span></el-col>
    </el-row>
    <!-- <span class="custom-tree-node-container" >
        <span>变量名称</span>
        <span>变量备注</span>
        <span>数据类型</span>
        <span>数据值</span>
        <span>操作</span>
    </span> -->
    <el-tree
      style="border: 1px solid #409EFF;"
      :data="treeData"
      node-key="idx"
      default-expand-all
      :expand-on-click-node="false">
      <el-row class="custom-tree-node" slot-scope="{ node, data }">
        <el-col :span="5"><div  class="custom-tree-node-item">{{data.name}}</div></el-col>
        <el-col :span="5"><div  class="custom-tree-node-item">{{data.label}}</div></el-col>
        <el-col :span="5"><div  class="custom-tree-node-item">{{data.dataType}}</div></el-col>
        <el-col :span="5"><div class="custom-tree-node-item">{{data.value}}</div></el-col>
        <el-col :span="4"><div  class="custom-tree-node-item">
          <el-button
            type="text"
            size="mini"
            @click="() => addConnectorParam(data)">
            添加
          </el-button>
          <el-button
            type="text"
            size="mini"
            @click="() => editConnectorParam(node, data)">
            编辑
          </el-button>
          <el-button
            type="text"
            size="mini"
            @click="() => deleteConnectorParam(node, data)">
            删除
          </el-button>
        </div></el-col>
      </el-row>
    </el-tree>

  </div>
</template>

<script>
let id = 1000;
export default {
  name: "ConnectorParamsComponent",
  props: {
    records: {
      type: Array
    },
  },
  created(){
    this.treeData = this.records
  },
  watch: {
  // 监听一个数组
  records: function (newVal, oldVal) {
    this.treeData = newVal
  },
},
  data() {
    return {
      treeData: [
        {
          id: 1,
          name: "Root",
          label: "Root",
          dataType: 'String',
          value: '上海市普陀区金沙江路 1519 弄',
          children: [],
        },
      ],
    };
  },
  methods: {
    append(data) {
      const newChild = { id: id++, label: "testtest", children: [] };
      if (!data.children) {
        this.$set(data, "children", []);
      }
      data.children.push(newChild);
    },
    addConnectorParam(data){
        this.$emit("addConnectorParam",data);
    },
    editConnectorParam(node, data){
      data.isEdit=true
      this.$emit("editConnectorParam",node,data);
    },

    deleteConnectorParam(node, data){
      this.$confirmDialog("确定要进行当前操作吗?",()=>{
        if(data.name=='root'){
          this.$errorMsg("根元素不能被删除")
          return;
        }
        const parent = node.parent;
        const children = parent.data.children || parent.data;
        const index = children.findIndex(d => d.idx === data.idx);
        children.splice(index, 1);
        this.$emit("deleteConnectorParam",data);
      });
    },
  },
};
</script>

<style>
  .el-tree-node__content{
    height: auto;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
    max-width: 100%;
  }

  .custom-tree-node-container{
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding:10px;
    background-color: #409EFF;
    color:white;
    text-align: center;
  }
  .custom-tree-node-item{
    width: 100%; /* 必须定义宽度根据需求设置，可设置百分百 */ 
    word-break: break-word; /* 文本行的任意字内断开 */ word-wrap: break-word; /* IE */ white-space: -hp-pre-wrap; /* HP printers */ white-space: -o-pre-wrap; /* Opera 7 */ white-space: -pre-wrap; /* Opera 4-6 */ white-space: -moz-pre-wrap; /* Mozilla */ white-space: pre; /* CSS2 */ white-space: pre-wrap; /* CSS 2.1 */ white-space: pre-line; /* CSS 3 (and 2.1 as well, actually) */
  }
</style>